module.exports = __webpack_public_path__ + "din.cd5dc4cb6453ab4c01df.svg";


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/themes/default/css/fonts/din.svg
// module id = ../../../../../src/app/themes/default/css/fonts/din.svg
// module chunks = 1